import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

gsap.registerEffect({
  name: 'lineAnimation',
  defaults: {
    duration: 1,
    start: 'top 80%'
  },
  effect: (target, vars) => {
    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: target,
        start: vars.start
      }
    })

    return tl.from(target, {
      x: '-100%',
      opacity: 0,
      duration: vars.duration
    })
  }
})

export * from 'gsap'
export { ScrollTrigger }
